import { IconChevronLeftSvg } from 'apps/sigma2-ui/src/components/svg/IconChevronLeft';
import { IconChevronRightSvg } from 'apps/sigma2-ui/src/components/svg/IconChevronRight';
import React from 'react';

export const LeftRightPager: React.FC<{
  isPreviousDisabled: boolean;
  onPrevious: () => void;
  isNextDisabled: boolean;
  onNext: () => void;
}> = ({ isPreviousDisabled, onPrevious, isNextDisabled, onNext }) => {
  return (
    <div className="flex flex-row items-center bg-white rounded-md h-8 shadow-8px">
      <button
        disabled={isPreviousDisabled}
        onClick={onPrevious}
        className="flex flex-col justify-center align-center text-gray-900 pl-5 pr-7 h-8 disabled:text-gray-300"
      >
        <IconChevronLeftSvg svg={{ className: 'w-4 h-4' }} />
      </button>
      <hr className={'w-[1px] h-3 bg-gray-900 opacity-10'} />
      <button
        disabled={isNextDisabled}
        onClick={onNext}
        className="flex flex-col justify-center align-center text-gray-900 pr-5 pl-7 h-8 disabled:text-gray-300"
      >
        <IconChevronRightSvg svg={{ className: 'w-4 h-4' }} />
      </button>
    </div>
  );
};
